export default "__VITE_ASSET__f59a442d__"